import { Entity } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { AdornisFilter } from '@adornis/filter/AdornisFilter.js';

@Entity()
export class AggregatedEntity extends AdornisEntity {
  static _baseCollectionName = '_empty'; // this has to be overriden
  static override _class = 'AggregatedEntity';

  static get baseCollectionName() {
    if (this._baseCollectionName === '_empty')
      throw new Error('baseCollectionName has to be overriden for: ' + this._class);
    return this._baseCollectionName;
  }

  static getFilter(): new () => AdornisFilter {
    throw new Error('This has to be overriden');
  }

  static getAggregation(
    filter: AdornisFilter,
    gqlFields: BaseQLSelectionSet,
  ): {
    entityDataAggregation: any[];
    postFieldResolverAggregation: any[];
  } {
    throw new Error('This has to be overriden');
  }
}
